import { useState, useCallback } from 'react';
import { d202Api } from '../../../services/d202Api';

export function useD202Navigation(onNavigate: (receiptNo: string) => Promise<void>) {
  const [allIds, setAllIds] = useState<string[]>([]);
  const [currentIdx, setCurrentIdx] = useState(-1);

  /** Load the full list of receipt IDs */
  const loadList = useCallback(async (): Promise<string[]> => {
    const res = await d202Api.list(1, 10000);
    const ids = (res.data || []).map(r => r.fd120_01).filter(Boolean);
    setAllIds(ids);
    return ids;
  }, []);

  /** Navigate to a specific index */
  const navTo = useCallback(async (idx: number, isEditing: boolean) => {
    if (idx < 0 || idx >= allIds.length || isEditing) return;
    setCurrentIdx(idx);
    await onNavigate(allIds[idx]);
  }, [allIds, onNavigate]);

  return {
    allIds, currentIdx,
    setAllIds, setCurrentIdx,
    loadList, navTo,
  };
}
